import {Collapsible} from '@chakra-ui/react'
import {Batch} from '@cypro/engine/schema'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {LuChevronDown} from 'react-icons/lu'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {AggregatedTable} from './aggregared-table'
import {ReactNode} from 'react'
import {IconType} from 'react-icons/lib'
import {MappedBatches, MappedRestVials} from '@cypro/engine/utils'

export interface AggregatedTableRow {
  batchId: string
  quantity: number
  sharedWith: string[]
  ordersSharingThisBatch?: string[] | undefined
  batchInfo: Batch
}

export function AggregatedCollapsible({
  title,
  mappedBatches,
  type,
  icon,
  mappedRestVials,
}: {
  mappedBatches: MappedBatches[]
  /** only for active substances: a rest vial replaces a vial, never a carrier, solvent or consumable */
  mappedRestVials?: MappedRestVials[]
  type: 'activeSubstances' | 'carrier' | 'solvents' | 'consumables'
  title: string
  icon: IconType | ReactNode
}) {
  // Total quantity based on batch type
  let totalQuantity = mappedBatches.reduce((sum, row) => sum + row.quantity, 0)
  if (mappedRestVials?.length) {
    totalQuantity += mappedRestVials.length
  }
  return (
    <Collapsible.Root bg="gray.50" borderRadius="md" borderWidth="1px">
      <Collapsible.Trigger
        paddingInline="3"
        width="full"
        display="flex"
        gap="2"
        alignItems="center"
        justifyContent={'space-between'}
      >
        <ResourceDrawerSummary title={title} description={`${totalQuantity} items`} icon={icon} />
        <Collapsible.Indicator transition="transform 0.2s" _open={{transform: 'rotate(180deg)'}}>
          <LuChevronDown />
        </Collapsible.Indicator>
      </Collapsible.Trigger>
      <Collapsible.Content padding="3">
        <FormSection variant="card" width={'100%'} bg="white">
          <AggregatedTable tableRows={mappedBatches} type={type} mappedRestVials={mappedRestVials} />
        </FormSection>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
